/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Provider } from '@angular/core';
import { BROWSER_PLUGINS } from 'crimson/lib/bridge/browser-plugin/browser-plugin-manager.service';
import { ApplicationControlPlugin } from './applicationcontrol/applicationcontrol';
import { ApplicationInfoPlugin } from './applicationinfo/applicationinfo';
import { ClientNotificationPlugin } from './clientnotification/clientnotification';
import { IpcPlugin } from './ipc/ipc';
import { SharedStoragePlugin } from './sharedstorage/sharedstorage';
import { SystemInfoPlugin } from './systeminfo/systeminfo';
import { UpdatePlugin } from './update/update';
import { WindowControlPlugin } from './windowcontrol/windowcontrol';
import { WindoweventsPlugin } from './windowevents/windowevents';

/**
 * Plugins that enable browser support for `Common` bridge commands
 */
export const CommonBrowserPluginsProvider: Provider[] = [
    {
        provide: BROWSER_PLUGINS,
        useClass: ApplicationControlPlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: IpcPlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: SharedStoragePlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: SystemInfoPlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: WindoweventsPlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: ApplicationInfoPlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: WindowControlPlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: UpdatePlugin,
        multi: true
    },
    {
        provide: BROWSER_PLUGINS,
        useClass: ClientNotificationPlugin,
        multi: true
    }
];
